import React, { useEffect, useMemo, useState } from "react";
import { useQuery, QueryResponseHandler } from "components/graphql";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";

import { UserData, ChangePasswordSection } from "./details-page";
import { getCurrentUserQuery } from "./profile-page";
import { getUserService } from "../../services/userServices";
import { useAuthDataContext } from "../../components/auth";
import { useCurrentCustomerContext } from "../../components/current-customer-context";

const UserProfilePage = () => {
  const { user } = useAuthDataContext();
  const { customers, contracts } = useCurrentCustomerContext();

  const [loadingResponse, setLoadingResponse] = useState(true);
  const [userResponse, setUserResponse] = useState(null);
  const [errorCallback, setErrorCallback] = useState(null);
  const query = useMemo(() => getCurrentUserQuery(), []);
  const { data, loading, error } = useQuery(query);

  const getUserCallback = response => {
    setLoadingResponse(false);
    const mockUser = {
      id: response.data._id,
      type: response.data.type,
      partnerId: data?.currentUser?.partnerId,
      ownedByPartnerId: data?.currentUser?.ownedByPartnerId,
      username: response.data.credentials.username,
      name: response.data.person.name,
      email: response.data.person.email,
      telephone: response.data.person.telephone,
      customerIds: data?.currentUser?.customerIds.slice(),
      serviceContractsFilter: response.data.service_contracts_filter,
      roles: data?.currentUser?.roles.slice(),
    };
    setUserResponse(mockUser);
  };

  const getUserErrorCallback = error => {
    console.error(error);
    setErrorCallback(error);
    setLoadingResponse(false);
  };

  useEffect(
    () => {
      setLoadingResponse(true);
      if (data?.currentUser) {
        getUserService(user?.sub, getUserCallback, getUserErrorCallback);
      }
    },
    [data?.currentUser],
  );

  return (
    <Dashboard>
      <QueryResponseHandler error={error || errorCallback} loading={loading || loadingResponse} elements={userResponse}>
        <PageHeaderBar title="app.page.user.profile" />
        <PageSection title="app.page.user.profile">
          <UserData user={userResponse} customers={customers} contracts={contracts} />
        </PageSection>

        {userResponse && (userResponse.type !== "EXT" || userResponse.type === null) && (
          <>
            <PageHeaderBar subtitle title="app.page.user.changepassword" />
            <PageSection>
              <ChangePasswordSection user={userResponse} />
            </PageSection>
          </>
        )}
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default UserProfilePage;
